'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiveProduct = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _reduxForm = require('redux-form');

var _sagaTools = require('@classpass/saga-tools');

var _reactRouterRedux = require('react-router-redux');

var _effects = require('redux-saga/effects');

var _reactIntl = require('react-intl');

var _cart = require('redux/modules/cart');

var _selectors = require('redux/saga/selectors');

var _Base = require('derivers/Base64');

var _Base2 = _interopRequireDefault(_Base);

var _AddressValidator = require('components/AddressForm/AddressValidator');

var _Validator = require('components/PaymentForm/Validator');

var _GoogleTagManager = require('components/GoogleTagManager/GoogleTagManager');

var _bound = require('redux/saga/entities/bound');

var _Plan = require('derivers/Plan');

var _Plan2 = _interopRequireDefault(_Plan);

var _helpers = require('redux/saga/helpers');

var _Authentication = require('features/Login/Authentication.saga');

var _msas = require('constants/msas');

var _multitrack = require('helpers/multitrack');

var _optimizely = require('helpers/optimizely');

var _verify = require('helpers/verify');

var _BaseProduct2 = require('./BaseProduct');

var _FormAction = require('../FormAction');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  required: {
    id: 'validations.genericRequired',
    defaultMessage: 'This field is required.'
  }
});

var liveProductValidator = function liveProductValidator(data, props) {
  var addressErrors = (0, _AddressValidator.addressValidator)(data, props);
  var paymentErrors = (0, _Validator.Validator)({ ccName: data.ccName });
  var errors = (0, _assign2.default)({}, addressErrors, paymentErrors);

  ['phone'].forEach(function (field) {
    if ((0, _verify.isBlank)(data[field])) {
      errors[field] = messages.required;
    }
  });

  return errors;
};

var getGTMObjectForStandalone = function getGTMObjectForStandalone(responseFromApi) {
  var msaAlias = (0, _msas.msaIdToAlias)(responseFromApi.msa_id);
  return {
    giftRedemption: responseFromApi.gift_redemption,
    planCode: responseFromApi.plan_code,
    purchasePlanId: responseFromApi.plan_id,
    taxAmount: responseFromApi.tax_amount,
    purchaseTransactionId: responseFromApi.id,
    msaId: responseFromApi.msa_id,
    msaName: msaAlias,
    currency: responseFromApi.currency_code,
    digitalPlanCode: responseFromApi.digital_subscription.name,
    digitalPurchasePlanId: responseFromApi.digital_subscription.plan_id
  };
};

var LiveProduct = exports.LiveProduct = function (_BaseProduct) {
  (0, _inherits3.default)(LiveProduct, _BaseProduct);

  function LiveProduct() {
    (0, _classCallCheck3.default)(this, LiveProduct);
    return (0, _possibleConstructorReturn3.default)(this, (LiveProduct.__proto__ || (0, _getPrototypeOf2.default)(LiveProduct)).apply(this, arguments));
  }

  (0, _createClass3.default)(LiveProduct, null, [{
    key: 'shouldActivate',
    value: function shouldActivate(params) {
      return !!params.encodedLivePlanId;
    }
  }, {
    key: 'loadLivePurchaseData',
    value: /*#__PURE__*/_regenerator2.default.mark(function loadLivePurchaseData(client, plan) {
      var assetCost, isTrial, isMonthly, isAnnual, hasLiveHardware, user;
      return _regenerator2.default.wrap(function loadLivePurchaseData$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              assetCost = plan.assets.reduce(function (acc, asset) {
                return acc + asset.amount / 100;
              }, 0);
              isTrial = _Plan2.default.isLiveTrial(plan);
              isMonthly = _Plan2.default.isLiveMonthly(plan);
              isAnnual = _Plan2.default.isLiveAnnual(plan);
              hasLiveHardware = _Plan2.default.hasLiveHardware(plan);
              _context.next = 7;
              return (0, _effects.all)([(0, _effects.put)((0, _reduxForm.change)('purchase', 'assets', plan.assets.map(function (_ref) {
                var amount = _ref.amount,
                    assetCode = _ref.assetCode,
                    sku = _ref.sku;
                return {
                  amount: amount,
                  assetCode: assetCode,
                  sku: sku,
                  include: true
                };
              }))), (0, _effects.put)((0, _cart.emptyCart)()), (0, _effects.put)((0, _cart.setTaxMethod)(_cart.TAX_METHOD_LEGACY)), (0, _effects.put)((0, _reduxForm.change)('purchase', 'isTrial', isTrial || isMonthly))] // Monthly plans are also considered trials
              );

            case 7:
              if (!isTrial) {
                _context.next = 12;
                break;
              }

              _context.next = 10;
              return (0, _effects.all)([(0, _effects.put)((0, _cart.addCartItem)('assets', 'Starter kit', 79, { isTaxable: false, isFree: true, description: 'One time fee' })), (0, _effects.put)((0, _cart.addCartItem)('plan', 'Monthly subscription', 19, { isTaxable: false, isFree: true, description: 'First month FREE' })), // TODO: Remove hardcoded price
              (0, _effects.put)((0, _cart.addCartItem)('shipping', 'Shipping fee', 0, { content: 'Free' }))]);

            case 10:
              _context.next = 30;
              break;

            case 12:
              if (!(isMonthly && hasLiveHardware)) {
                _context.next = 17;
                break;
              }

              _context.next = 15;
              return (0, _effects.all)([(0, _effects.put)((0, _cart.addCartItem)('assets', 'Starter kit', assetCost, { isTaxable: false })), (0, _effects.put)((0, _cart.addCartItem)('plan', 'Monthly subscription', plan.recurringAmount / 100, { isTaxable: false, isFree: true, description: 'First month FREE' })), (0, _effects.put)((0, _cart.addCartItem)('shipping', 'Shipping fee', 0, { content: 'Free' }))]);

            case 15:
              _context.next = 30;
              break;

            case 17:
              if (!isMonthly) {
                _context.next = 22;
                break;
              }

              _context.next = 20;
              return (0, _effects.all)([(0, _effects.put)((0, _cart.addCartItem)('plan', 'Monthly subscription', plan.recurringAmount / 100, { isTaxable: false, isFree: true, description: 'First month FREE' }))]);

            case 20:
              _context.next = 30;
              break;

            case 22:
              if (!(isAnnual && hasLiveHardware)) {
                _context.next = 27;
                break;
              }

              _context.next = 25;
              return (0, _effects.all)([(0, _effects.put)((0, _cart.addCartItem)('plan', 'Annual subscription rate', plan.initialAmount / 100 + assetCost, { isTaxable: false })), (0, _effects.put)((0, _cart.addCartItem)('shipping', 'Shipping fee', 0, { content: 'Free' }))]);

            case 25:
              _context.next = 30;
              break;

            case 27:
              if (!isAnnual) {
                _context.next = 30;
                break;
              }

              _context.next = 30;
              return (0, _effects.all)([(0, _effects.put)((0, _cart.addCartItem)('plan', 'Annual subscription rate', plan.initialAmount / 100 + assetCost, { isTaxable: false }))]);

            case 30:
              _context.next = 32;
              return (0, _effects.call)(_sagaTools.fetchEntity, _bound.userProfile, [client]);

            case 32:
              user = _context.sent;

              if (!(user.contact_info && user.contact_info.address)) {
                _context.next = 36;
                break;
              }

              _context.next = 36;
              return (0, _effects.all)([(0, _effects.put)((0, _reduxForm.change)('purchase', 'address1', user.contact_info.address.address1)), (0, _effects.put)((0, _reduxForm.change)('purchase', 'address2', user.contact_info.address.address2)), (0, _effects.put)((0, _reduxForm.change)('purchase', 'city', user.contact_info.address.city)), (0, _effects.put)((0, _reduxForm.change)('purchase', 'state', user.contact_info.address.state)), (0, _effects.put)((0, _reduxForm.change)('purchase', 'country', 'USA')), (0, _effects.put)((0, _reduxForm.change)('purchase', 'phone', user.contact_info.phone)), (0, _effects.put)((0, _reduxForm.change)('purchase', 'postalCode', user.contact_info.address.postal_code))]);

            case 36:
            case 'end':
              return _context.stop();
          }
        }
      }, loadLivePurchaseData, this);
    })
  }, {
    key: 'loadPurchaseData',
    value: /*#__PURE__*/_regenerator2.default.mark(function loadPurchaseData(client, _ref2) {
      var _ref2$encodedStandalo = _ref2.encodedStandalonePlanId,
          encodedStandalonePlanId = _ref2$encodedStandalo === undefined ? false : _ref2$encodedStandalo,
          encodedLivePlanId = _ref2.encodedLivePlanId;

      var livePlanId, standalonePlanId, msa, msaId, _ref3, _ref4, plans, plan;

      return _regenerator2.default.wrap(function loadPurchaseData$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              livePlanId = _Base2.default.decodeNumber(encodedLivePlanId);
              standalonePlanId = _Base2.default.decodeNumber(encodedStandalonePlanId);
              _context2.next = 4;
              return (0, _effects.call)(_helpers.geodetectMsa, client);

            case 4:
              msa = _context2.sent;
              msaId = msa ? msa.id : _msas.LIVE_DEFAULT_MSA;
              _context2.next = 8;
              return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.livePlansByMsa, [client, msaId]), (0, _effects.put)((0, _reduxForm.change)('purchase', 'planId', standalonePlanId)), (0, _effects.put)((0, _reduxForm.change)('purchase', 'livePlanId', livePlanId)), (0, _effects.put)((0, _reduxForm.change)('purchase', 'msaId', msaId))]);

            case 8:
              _ref3 = _context2.sent;
              _ref4 = (0, _slicedToArray3.default)(_ref3, 1);
              plans = _ref4[0];
              plan = plans.find(function (p) {
                return p.planId === livePlanId;
              }) || {};
              _context2.next = 14;
              return LiveProduct.loadLivePurchaseData(client, plan);

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, loadPurchaseData, this);
    })
  }, {
    key: 'postPurchase',
    value: /*#__PURE__*/_regenerator2.default.mark(function postPurchase(result) {
      return _regenerator2.default.wrap(function postPurchase$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0, _effects.call)(LiveProduct.trackPurchaseSuccess, result);

            case 2:
              _context3.next = 4;
              return (0, _effects.put)((0, _reactRouterRedux.replace)('/videos'));

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, postPurchase, this);
    })
  }, {
    key: 'submitPurchaseData',
    value: /*#__PURE__*/_regenerator2.default.mark(function submitPurchaseData(client, currentUserId, _ref5, consents) {
      var address1 = _ref5.address1,
          address2 = _ref5.address2,
          city = _ref5.city,
          state = _ref5.state,
          country = _ref5.country,
          _ref5$phone = _ref5.phone,
          phone = _ref5$phone === undefined ? '' : _ref5$phone,
          postalCode = _ref5.postalCode,
          assets = _ref5.assets,
          livePlanId = _ref5.livePlanId,
          planId = _ref5.planId,
          msaId = _ref5.msaId,
          ccZip = _ref5.ccZip,
          stripeTokenPromiseKey = _ref5.stripeTokenPromiseKey;

      var _ref6, _ref7, purchase;

      return _regenerator2.default.wrap(function submitPurchaseData$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _effects.all)([(0, _effects.call)((0, _get3.default)(LiveProduct.__proto__ || (0, _getPrototypeOf2.default)(LiveProduct), 'submitPurchaseData', this), client, currentUserId, {
                stripeTokenPromiseKey: stripeTokenPromiseKey,
                ccZip: ccZip,
                planId: planId,
                msaId: msaId,
                livePlanId: livePlanId,
                assets: assets.filter(function (asset) {
                  return asset.include;
                }).map(function (asset) {
                  return asset.assetCode;
                })
              }, consents), (0, _effects.call)(client.users.updateUserProfile, {
                contact_info: {
                  address: {
                    address1: address1,
                    address2: address2,
                    city: city,
                    state: state,
                    country: country,
                    postal_code: postalCode
                  },
                  phone: phone
                }
              })]);

            case 2:
              _ref6 = _context4.sent;
              _ref7 = (0, _slicedToArray3.default)(_ref6, 1);
              purchase = _ref7[0];
              _context4.next = 7;
              return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntity, _bound.userPermissions, [client, currentUserId]), (0, _effects.call)(_sagaTools.fetchEntity, _bound.userProfile, [client]), (0, _effects.put)(_bound.liveSubscription.resetAction())]);

            case 7:
              return _context4.abrupt('return', purchase);

            case 8:
            case 'end':
              return _context4.stop();
          }
        }
      }, submitPurchaseData, this);
    })
  }, {
    key: 'trackPurchaseSuccess',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackPurchaseSuccess(result) {
      var _ref8, _ref9, cart, userId, digitalPurchaseType, gtmResultMappingObject, gtmDataObject, calls;

      return _regenerator2.default.wrap(function trackPurchaseSuccess$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return (0, _effects.all)([(0, _effects.select)(_cart.selectCart), (0, _effects.select)(_selectors.userId)]);

            case 2:
              _ref8 = _context5.sent;
              _ref9 = (0, _slicedToArray3.default)(_ref8, 2);
              cart = _ref9[0];
              userId = _ref9[1];
              digitalPurchaseType = 'standalone';
              gtmResultMappingObject = getGTMObjectForStandalone(result);
              gtmDataObject = (0, _assign2.default)(gtmResultMappingObject, {
                event: 'cplive_purchase',
                userId: userId,
                purchaseChargeAmount: cart.debitTotal,
                digitalPurchaseType: digitalPurchaseType
              });
              calls = [(0, _effects.call)(_GoogleTagManager.trackGoogleTagManagerEvent, gtmDataObject), (0, _effects.call)(_optimizely.trackOptimizelyEvent, 'successful_cplive_purchase')];
              _context5.next = 12;
              return (0, _effects.all)(calls);

            case 12:
            case 'end':
              return _context5.stop();
          }
        }
      }, trackPurchaseSuccess, this);
    })
  }, {
    key: 'loadSignupData',
    value: /*#__PURE__*/_regenerator2.default.mark(function loadSignupData(client, _ref10) {
      var encodedPlanId = _ref10.encodedPlanId;
      var decodedPlanId;
      return _regenerator2.default.wrap(function loadSignupData$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              decodedPlanId = _Base2.default.decodeNumber(encodedPlanId);
              _context6.next = 3;
              return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.planById, [client, decodedPlanId]);

            case 3:
              _context6.next = 5;
              return (0, _effects.put)((0, _reduxForm.change)('signup', 'planId', decodedPlanId));

            case 5:
            case 'end':
              return _context6.stop();
          }
        }
      }, loadSignupData, this);
    })
  }, {
    key: 'submitSignupData',
    value: /*#__PURE__*/_regenerator2.default.mark(function submitSignupData(client, basePayload, formData) {
      return _regenerator2.default.wrap(function submitSignupData$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return (0, _effects.call)(_Authentication.createUserAndLogIn, client, _FormAction.signup, (0, _extends3.default)({}, basePayload, {
                plan_id: formData.planId
              }));

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, submitSignupData, this);
    })
  }, {
    key: 'trackPurchaseFailure',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackPurchaseFailure() {
      var _ref11, livePlanId;

      return _regenerator2.default.wrap(function trackPurchaseFailure$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return (0, _effects.select)(_BaseProduct2.getPurchaseFormValues);

            case 2:
              _ref11 = _context8.sent;
              livePlanId = _ref11.livePlanId;
              _context8.next = 6;
              return (0, _effects.spawn)(_multitrack.ga, 'CP Live Purchases', 'CP Live Purchase Errors', 'digital-plan-' + livePlanId);

            case 6:
            case 'end':
              return _context8.stop();
          }
        }
      }, trackPurchaseFailure, this);
    })
  }, {
    key: 'onPurchaseTracking',
    value: /*#__PURE__*/_regenerator2.default.mark(function onPurchaseTracking() {
      return _regenerator2.default.wrap(function onPurchaseTracking$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
            case 'end':
              return _context9.stop();
          }
        }
      }, onPurchaseTracking, this);
    }) // eslint-disable-line no-empty-function

  }, {
    key: 'onLoadTracking',
    value: /*#__PURE__*/_regenerator2.default.mark(function onLoadTracking() {
      return _regenerator2.default.wrap(function onLoadTracking$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
            case 'end':
              return _context10.stop();
          }
        }
      }, onLoadTracking, this);
    }) // eslint-disable-line no-empty-function

  }]);
  return LiveProduct;
}(_BaseProduct2.BaseProduct);

LiveProduct.key = 'LiveProduct';
LiveProduct.pathAlias = 'live';
LiveProduct.validator = liveProductValidator;